import { render, staticRenderFns } from "./App.vue?vue&type=template&id=415ba9d9&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CColorModeProvider: require('@chakra-ui/vue').CColorModeProvider})
